<template>
  <!-- 权限管理 -->
  <div class="edu_pages">
    <!-- 暂无权限 -->
    <the-no-authority v-if="!authority"></the-no-authority>

    <template v-if="authority">
      <div class="edu_pages_content_box">
        <div class="edu_page_title_box">
          <div class="title_box">
            <div class="color_lump_box"></div>
            <span>权限管理</span>
          </div>
          <div class="edu_operation_box">
            <div class="add_icon_box button-box" @click="openAddBox()">
              <div></div>
              <span>新增</span>
            </div>
            <div
              class="forbidden_icon_box button-box"
              @click="setRoleStatus(0, selectedListData)"
            >
              <div></div>
              <span>禁用</span>
            </div>
            <div
              class="invoke_icon_box button-box"
              @click="setRoleStatus(1, selectedListData)"
            >
              <div></div>
              <span>启用</span>
            </div>
          </div>
        </div>
        <div class="edu_pages_content_body_box">
          <div class="edu_table_box">
            <el-table
              :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
              :data="dataList.list"
              height="100%"
              class="table_box"
              @selection-change="selectListData"
            >
              <el-table-column type="selection" width="55" align="center">
              </el-table-column>
              <el-table-column label="序号" width="70" align="center">
                <template slot-scope="scope">
                  {{
                    dataList.pageSize * (dataList.pageNum - 1) +
                      scope.$index +
                      1
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="roleName"
                label="角色名称"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="roleDescription"
                label="角色描述"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="roleStatus"
                label="角色状态"
                width="150"
                align="center"
              >
                <template slot-scope="rowData">
                  <el-tag type="danger" v-if="rowData.row.roleStatus == 0">
                    禁用
                  </el-tag>
                  <el-tag type="warning" v-else>
                    启用
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" align="center">
                <template slot-scope="rowData">
                  <el-link
                    type="primary"
                    @click="getDataOne(rowData.row)"
                    :underline="false"
                    >编辑</el-link
                  >
                  <el-divider direction="vertical"></el-divider>
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          @click="delData(rowData.row.roleId)"
                          :underline="false"
                          >删除</el-link
                        ></el-dropdown-item
                      >
                      <el-dropdown-item
                        class="dropdown_item_box"
                        divided
                        v-if="rowData.row.roleStatus == 0"
                        ><el-link
                          class="link_box"
                          type="primary"
                          @click="setRoleStatus(1, [rowData.row.roleId])"
                          :underline="false"
                          >启用</el-link
                        ></el-dropdown-item
                      >
                      <el-dropdown-item v-else class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          @click="setRoleStatus(0, [rowData.row.roleId])"
                          :underline="false"
                          >禁用</el-link
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          @click="memberAddClick(rowData.row.roleId)"
                          :underline="false"
                          >成员新增</el-link
                        ></el-dropdown-item
                      >
                      <el-dropdown-item class="dropdown_item_box"
                        ><el-link
                          class="link_box"
                          type="primary"
                          @click="memberListClick(rowData.row.roleId)"
                          :underline="false"
                          >成员管理</el-link
                        ></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="edu_pagination_box">
            <el-pagination
              @current-change="handleCurrentChange"
              background
              :current-page="dataList.pageNum"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="listRequestData.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="dataList.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </template>
    <member-table-dialog
      :showDialog="mShowDialog"
      :roleId="roleId"
      @close="mClose"
    ></member-table-dialog>
    <member-add-dialog
      :showDialog="aShowDialog"
      :roleId="roleId"
      @close="aClose"
    ></member-add-dialog>
    <add-or-edit
      :dialogInfo="addOrEditInfo"
      :dialogType="dialogType"
      :showDialog="showDialog"
      @close="close"
      @saveClick="saveClick"
    ></add-or-edit>
  </div>
</template>

<script>
import theNoAuthority from "@/components/theNoAuthority.vue";
import MemberTableDialog from "./components/MemberTableDialog.vue";
import MemberAddDialog from "./components/MemberAddDialog.vue";
import AuthorityAddOrEditDialog from "./components/AuthorityAddOrEditDialog.vue";
export default {
  name: "",
  components: {
    MemberTableDialog,
    MemberAddDialog,
    addOrEdit: AuthorityAddOrEditDialog
  },
  props: {},
  data() {
    return {
      // 有无权限
      authority: true,
      listRequestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 20,
        roleName: ""
      },
      dataList: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      selectedListData: [],
      mShowDialog: false,
      roleId: "",
      aShowDialog: false,
      addOrEditInfo: {},
      dialogType: "add",
      showDialog: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    selectListData(data) {
      this.selectedListData = data.map((item, index) => {
        return item.roleId;
      });
    },
    // 更改角色状态
    async setRoleStatus(category, roleId) {
      if (roleId.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择需要操作的角色"
        });
        return;
      }
      let requestData = {
        category: category,
        roleId: roleId
      };
      let res = await this.$Http.setRoleStatus(requestData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    openAddBox() {
      this.showDialog = true;
      this.dialogType = "add";
      this.addOrEditInfo = {
        eduId: this.$store.getters.getEduData.eduId,
        roleName: "",
        roleDescription: ""
      };
    },
    close() {
      this.showDialog = false;
    },
    saveClick(info) {
      if (this.dialogType == "add") {
        this.addDataInfo(info);
      } else {
        this.editDataAction(info);
      }
    },
    handleCurrentChange(val) {
      this.listRequestData.pageNum = val;
      this.getDataList();
    },
    getDataOne(dataInfo) {
      this.showDialog = true;
      this.dialogType = "edit";
      this.addOrEditInfo = dataInfo;
    },
    async getDataList() {
      let res = await this.$Http.getEduRole(this.listRequestData, true);
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.total;
        this.dataList.pages = res.data.pages;
        this.dataList.list = res.data.list;
      } else if (res.code == 101) {
      } else if (res.code == 102) {
        this.authority = false;
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    async addDataInfo(info) {
      let res = await this.$Http.addEduRole(info, true);
      if (res.code == 200) {
        this.getDataList();
        this.close();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    async editDataAction(info) {
      let res = await this.$Http.editEduRole(info, true);
      if (res.code == 200) {
        this.getDataList();
        this.close();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 删除数据
    delData(dataId) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            roleId: [dataId]
          };
          let res = await this.$Http.delEduRole(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    // 获取数据列表
    memberListClick(id) {
      this.roleId = id + "";
      this.mShowDialog = true;
    },
    mClose() {
      this.mShowDialog = false;
    },
    memberAddClick(id) {
      this.roleId = id + "";
      this.aShowDialog = true;
    },
    aClose() {
      this.aShowDialog = false;
    }
  },
  created() {
    this.getDataList();
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
@import "../../../../public/css/edu_pages.scss";
</style>
